import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/** Returns whether the Invite Name feature is enabled; used by DataBlockMenu, VisitorFieldSettings, and form blocks. */
export function useInviteNameEnabled(): boolean {
  return useFlag<boolean>(FeatureFlag.VisitorInviteName, false) ?? false;
}
